import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import server from '../../_api/backend';
import * as toast from '../../_store/slice/toast';

type FormValues = {
  name: string;
  email: string;
  tel: {
    pre: string;
    mid: string;
    post: string;
  };
  phone: {
    fst: string;
    scd: string;
    thr: string;
  };
  contents: string;
};

export function Publish(props: RouteComponentProps) {
  const dispatch = useDispatch();
  let telPre = '';
  let telMid = '';
  let telEnd = '';

  useEffect(() => {
    if (window.localStorage.getItem('token') === null) {
      dispatch(toast.error({ message: '로그인이 필요합니다.' }));
      props.history.push('/login');
    } else {
      getUserInfo();
    }
  }, []);

  const [formValues, setFormValues] = useState<FormValues>({
    name: '',
    email: '',
    tel: {
      pre: '',
      mid: '',
      post: '',
    },
    phone: {
      fst: '',
      scd: '',
      thr: '',
    },
    contents: '',
  });

  // 유저 정보 가져오기
  const getUserInfo = async () => {
    await server
      .getUserOwn()
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          if (payload.tel !== undefined) {
            const telEach = payload.tel.split('-');
            telPre = String(telEach[0]);
            telMid = String(telEach[1]);
            telEnd = String(telEach[2]);
            setFormValues({
              ...formValues,
              name: payload.name,
              email: payload.email,
              tel: { pre: telPre, mid: telMid, post: telEnd },
            });
          }
          if (payload.phone !== undefined) {
            const phoneEach = payload.phone.split('-');
            const phonePre = phoneEach[0];
            const phoneMid = phoneEach[1];
            const phoneEnd = phoneEach[2];
            setFormValues({
              ...formValues,
              name: payload.name,
              email: payload.email,
              tel: { pre: telPre, mid: telMid, post: telEnd },
              phone: { fst: phonePre, scd: phoneMid, thr: phoneEnd },
            });
          }
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // 신청하기 버튼 클릭 시 (Validation)
  const onClickSaveData = async () => {
    const { pre, mid, post } = formValues.tel;
    const { fst, scd, thr } = formValues.phone;
    const savingData = {
      ...formValues,
      tel: `${pre}-${mid}-${post}`,
      phone: `${fst}-${scd}-${thr}`,
    };
    if (formValues.name === '') {
      dispatch(toast.error({ message: '이름을 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (formValues.email === '') {
      dispatch(toast.error({ message: '이메일을 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (formValues.phone.fst === '' || formValues.phone.scd === '' || formValues.phone.thr === '') {
      dispatch(
        toast.error({ message: '휴대폰 번호를 확인해주세요.', title: '필수 입력 항목 누락' })
      );
      return;
    }
    if (formValues.contents === '') {
      dispatch(toast.error({ message: '내용을 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (formValues !== undefined) {
      await server
        .addPublication(savingData)
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            dispatch(toast.info({ message: '출판문의가 접수되었습니다.' }));
            props.history.push('/');
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
  };

  // Publish 리턴값
  return (
    <div className="content">
      <div className="breadscrumb">
        <>Home</>
        {' > '}
        <>출판문의 (저작자 전용)</>
      </div>
      <div className="title">
        <h2>출판문의 (저작자 전용)</h2>
        <p>도서출판 구민사는 저자의 출판계획과 관련된 문의를 기다립니다.</p>
        <p style={{ color: 'red' }}>
          ※ 입금, 주문, 배송, 자료 요청 관련 문의는 고객센터(02-701-7421~2)로 연락해 주시기
          바랍니다.
        </p>
      </div>
      <section>
        <ul className="inputs">
          <li>
            <span className="required">이름</span>
            <input
              type="text"
              value={formValues.name}
              onChange={(event) => {
                setFormValues({ ...formValues, name: event.target.value });
              }}
            />
          </li>
          <li>
            <span className="required">이메일</span>
            <input
              type="email"
              value={formValues.email}
              onChange={(event) => {
                setFormValues({ ...formValues, email: event.target.value });
              }}
            />
          </li>
          <li className="phone">
            <span>전화번호</span>
            <div>
              <input
                type="number"
                value={formValues.tel.pre}
                maxLength={3}
                onChange={(event) => {
                  setFormValues({
                    ...formValues,
                    tel: {
                      ...formValues?.tel,
                      pre: event.target.value,
                    },
                  });
                }}
              />
              <span>-</span>
              <input
                type="number"
                value={formValues.tel.mid}
                maxLength={4}
                onChange={(event) => {
                  setFormValues({
                    ...formValues,
                    tel: {
                      ...formValues?.tel,
                      mid: event.target.value,
                    },
                  });
                }}
              />
              <span>-</span>
              <input
                type="number"
                value={formValues.tel.post}
                maxLength={4}
                onChange={(event) => {
                  setFormValues({
                    ...formValues,
                    tel: {
                      ...formValues?.tel,
                      post: event.target.value,
                    },
                  });
                }}
              />
            </div>
          </li>
          <li className="phone">
            <span className="required">휴대폰</span>
            <div>
              <input
                type="number"
                value={formValues.phone.fst}
                maxLength={3}
                onChange={(event) => {
                  setFormValues({
                    ...formValues,
                    phone: {
                      ...formValues?.phone,
                      fst: event.target.value,
                    },
                  });
                }}
              />
              <span>-</span>
              <input
                type="number"
                value={formValues.phone.scd}
                maxLength={4}
                onChange={(event) => {
                  setFormValues({
                    ...formValues,
                    phone: {
                      ...formValues?.phone,
                      scd: event.target.value,
                    },
                  });
                }}
              />
              <span>-</span>
              <input
                type="number"
                value={formValues.phone.thr}
                maxLength={4}
                onChange={(event) => {
                  setFormValues({
                    ...formValues,
                    phone: {
                      ...formValues?.phone,
                      thr: event.target.value,
                    },
                  });
                }}
              />
            </div>
          </li>
          <li>
            <span className="required">내용</span>
            <textarea
              name=""
              id=""
              rows={20}
              value={formValues.contents}
              onChange={(event) => {
                setFormValues({ ...formValues, contents: event.target.value });
              }}
            />
          </li>
        </ul>
        <div className="buttons">
          <button type="button" className="btn-main" onClick={() => onClickSaveData()}>
            신청하기
          </button>
        </div>
      </section>
    </div>
  );
}
